define('catalogsCreateView',[
  'module',
  'marionette',
  'underscore',
  'app',
  'template!catalogsCreateTpl',
  'dynamicTextView',
  'catalogEntities',
  'entities/dynamic_text'
], function (
  Module,
  Marionette,
  _,
  App,
  Tpl,
  DynamicTextView
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'catalogs-create-view',

    regions: {
      nameRegion: '.name-region'
    },

    initialize: function () {
      // Ensure a DynamicText model is attached to the Catalog.name relation
      var nameModel = this.model.get('name');
      if (!nameModel || !_.isFunction(nameModel.getTranslationCollection)) {
        nameModel = App.request('dynamic-text:model', { values: {} });
        this.model.set('name', nameModel);
      }
      this.nameDtModel = nameModel;
    },

    onShow: function () {
      this.nameDtView = new DynamicTextView({
        model: this.nameDtModel,
        noSaving: true,
        hideGlossary: true
      });
      // No need to mirror values into a separate attribute; the header confirm
      // will read from this.model.get('name') directly.
      this.getRegion('nameRegion').show(this.nameDtView);
    }
  });
});

